import React from 'react';
import type { MouseEvent } from 'react';
import type { Theme } from '@material-ui/core';
import { Popper, Box, IconButton, ClickAwayListener } from '@material-ui/core';
import { IconName, Illustration } from '@klp/design/Illustrations';
import { useKlpStyles } from '@klp/design/Theme/useKlpStyles';
import { LeverandorActionsList } from '../LeverandorActions/LeverandorActionList';
import type { LeverandorGodkjenningProsessResponse } from '@klp/leverandor/types';

const styles = (theme: Theme) => ({
    popper: {
        background: theme.palette.background.paper,
        border: '1px solid transparent',
        borderColor: theme.palette.primary.dark,
        borderRadius: theme.shape.borderRadius,
        zIndex: 1000,
    },
    button: {
        borderRadius: '50%',
        cursor: 'pointer',
    },
});

interface PopperProps {
    leverandor: LeverandorGodkjenningProsessResponse;
    isEDAdmin: boolean | undefined;
    open: boolean;
    anchorEl: HTMLElement | null;
    onToggle: (event: MouseEvent<HTMLButtonElement>) => void;
    onClose: () => void;
}

export const MenuPopper: React.FC<PopperProps> = ({
    leverandor,
    isEDAdmin = false,
    open,
    anchorEl,
    onToggle,
    onClose,
}) => {
    const classes = useKlpStyles({}, styles);

    const handleToggle = (event: MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        onToggle(event);
    };

    return (
        <ClickAwayListener onClickAway={onClose}>
            <div>
                <IconButton
                    color="inherit"
                    aria-label="Open document view"
                    onClick={handleToggle}
                    className={classes.button}
                >
                    <Illustration icon={IconName.OPTIONS} />
                </IconButton>

                <Popper
                    id={open ? 'transition-popper' : undefined}
                    open={open}
                    anchorEl={anchorEl}
                    placement="bottom-start"
                    transition={true}
                    className={classes.popper}
                >
                    <Box>
                        <LeverandorActionsList
                            leverandor={leverandor}
                            isEDAdmin={isEDAdmin}
                            onClose={onClose}
                        />
                    </Box>
                </Popper>
            </div>
        </ClickAwayListener>
    );
};
